<template lang="pug">
.wrap
  page-title Add a new survey

  survey-form(v-model='survey' @save='onSave')

</template>

<script>
import { mapGetters, mapActions } from "vuex";

import PageTitle from "@/shared/components/layout/PageTitle";
import SurveyForm from "@/insight/components/sections/surveys/SurveyForm";
import CrudMixin from "@/shared/mixins/Crud";

export default {
  components: { PageTitle, SurveyForm },
  mixins: [CrudMixin],
  data() {
    return {
      loading: false,
      survey: {
        title: "",
        content: "",
        status: "draft",
        startDatetime: null,
        endDatetime: null,
        timezone: "",
        assignees: [],
        fields: []
      }
    };
  },
  computed: {
    ...mapGetters("auth", ["activeCompany"])
  },
  methods: {
    ...mapActions("surveys", ["createSurvey"]),
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const newData = {
        ...this.survey,
        company: this.activeCompany.id,
        assigneeUserIds: this.survey.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.survey.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };

      this.wrapApiAction(this.createSurvey)({ data: newData }).then(data => {
        this.$router.push({
          name: "insight:surveyEdit",
          params: { surveyId: data.id }
        });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
